export default "/chevron-down.48ffb24fd0809821783b403a02dd90b8.svg";